

/**
 * @description Controller for the email confirmation workflow
 * @param {Angular} $stateParams The $stateParams service
 * @param {service} EmailConfirmation The EmailConfirmation service
 */
function EmailConfirmationController(
  $stateParams
) {
  let vm = this;

  vm.$onInit = function() {
    if (vm.response && vm.response.status) {
      vm.emailIsConfirmed = false;
    } else {
      vm.collector = vm.response;
      vm.emailIsConfirmed = true;
    }
  };
}

angular
  .module('inkfinder')
  .controller('EmailConfirmationController', EmailConfirmationController);



// WEBPACK FOOTER //
// ./components/collector/email-confirmation/email-confirmation.controller.js